<div class="px-6 py-4 border-b border-gray-100 bg-white flex flex-row justify-between items-center gap-4">
  <div class="flex items-center gap-3">
    <span class="po-card-icon !h-10 !w-10"><mat-icon>person_add</mat-icon></span>
    <div>
      <h1 class="text-xl font-bold text-gray-900 leading-tight">New supplier</h1>
      <p class="text-xs text-gray-500">Added and picked on this purchase order - nothing on the form is lost</p>
    </div>
  </div>
  <button type="button" (click)="cancel()" class="h-9 w-9 rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-800 flex items-center justify-center transition-colors flex-shrink-0" aria-label="Close" matTooltip="Close">
    <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">close</mat-icon>
  </button>
</div>

<mat-dialog-content class="mat-typography !px-6 !py-5 !max-h-[68vh]">
  <form class="flex flex-col gap-4" (ngSubmit)="onSave()">
    <div>
      <label class="po-label" for="qs-name">Supplier name <span class="text-red-500">*</span></label>
      <div class="relative">
        <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 !text-gray-400 !text-[18px] !h-[18px] !w-[18px] pointer-events-none">storefront</mat-icon>
        <input id="qs-name" name="name" type="text" cdkFocusInitial placeholder="e.g. Rajasthan Stone Exports Pvt Ltd" class="po-field !pl-10 font-semibold"
          [ngClass]="(submitted && !name.trim()) ? '!border-red-300' : (duplicateSupplier ? '!border-amber-300' : '')" [(ngModel)]="name" />
      </div>
      @if (submitted && !name.trim()) {
      <div class="text-xs text-red-600 mt-1.5">Supplier name is required</div>
      } @else {
      @if (duplicateSupplier; as dup) {
      <div class="mt-2 flex items-center gap-2 text-xs text-amber-900 bg-amber-50 border border-amber-200 rounded-xl px-3 py-2">
        <mat-icon class="!text-[16px] !h-4 !w-4 flex-shrink-0">warning_amber</mat-icon>
        <span class="flex-1">"{{ dup.name }}" already exists.</span>
        <button type="button" class="font-semibold px-2.5 py-1 rounded-lg bg-white border border-amber-200 hover:bg-amber-100 transition-colors whitespace-nowrap" (click)="useExisting(dup)">Use that one</button>
      </div>
      }
      }
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <label class="po-label" for="qs-email">Email</label>
        <div class="relative">
          <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 !text-gray-400 !text-[18px] !h-[18px] !w-[18px] pointer-events-none">mail</mat-icon>
          <input id="qs-email" name="email" type="email" placeholder="orders@supplier.com" class="po-field !pl-10" [ngClass]="emailInvalid ? '!border-red-300' : ''" [(ngModel)]="email" />
        </div>
        @if (emailInvalid) { <div class="text-xs text-red-600 mt-1.5">Not a valid email address</div> }
        @else if (!email.trim()) { <div class="text-[11px] text-gray-400 mt-1.5">Needed to send the PO to them</div> }
      </div>
      <div>
        <label class="po-label" for="qs-phone">Phone</label>
        <div class="relative">
          <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 !text-gray-400 !text-[18px] !h-[18px] !w-[18px] pointer-events-none">call</mat-icon>
          <input id="qs-phone" name="phone" type="tel" placeholder="+44 1234 567890" class="po-field !pl-10" [(ngModel)]="phone" />
        </div>
      </div>
      <div>
        <label class="po-label" for="qs-country">Country</label>
        <div class="relative">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 text-lg leading-none pointer-events-none">
            @if (countryMatch; as c) { {{ countryFlag(c.code) }} } @else { <mat-icon class="!text-gray-400 !text-[18px] !h-[18px] !w-[18px] align-middle">public</mat-icon> }
          </span>
          <input id="qs-country" name="country" type="text" autocomplete="off" placeholder="Search countries" class="po-field !pl-11"
            [value]="country" [matAutocomplete]="countryAuto" (input)="country = $any($event.target).value" />
        </div>
        <mat-autocomplete #countryAuto="matAutocomplete" class="po-ac-panel" [hideSingleSelectionIndicator]="true" (optionSelected)="country = $event.option.value">
          @for (c of filteredCountries; track c.code) {
          <mat-option [value]="c.name">
            <div class="flex items-center gap-3 py-1.5 text-sm">
              <span class="text-lg leading-none">{{ countryFlag(c.code) }}</span>
              <span class="text-gray-900">{{ c.name }}</span>
              <span class="ml-auto text-[11px] font-mono text-gray-400">{{ c.code }}</span>
            </div>
          </mat-option>
          }
        </mat-autocomplete>
      </div>
      <div>
        <label class="po-label" for="qs-city">City</label>
        <input id="qs-city" name="city" type="text" placeholder="City" class="po-field" [(ngModel)]="city" />
      </div>
      <div class="sm:col-span-2">
        <label class="po-label" for="qs-vat">VAT number</label>
        <div class="relative">
          <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 !text-gray-400 !text-[18px] !h-[18px] !w-[18px] pointer-events-none">receipt</mat-icon>
          <input id="qs-vat" name="vat" type="text" placeholder="Optional" class="po-field !pl-10 font-mono uppercase" [(ngModel)]="vatNumber" />
        </div>
      </div>
    </div>

    <div class="flex items-start gap-2 text-[11px] text-gray-400">
      <mat-icon class="!text-[14px] !h-3.5 !w-3.5 flex-shrink-0 mt-px">info</mat-icon>
      <span>The full address, website and notes can be added later on the supplier's own page.</span>
    </div>
    <!-- Lets Enter in any field submit the form. -->
    <button type="submit" class="hidden" aria-hidden="true" tabindex="-1"></button>
  </form>
</mat-dialog-content>

<div class="px-6 py-4 border-t border-gray-100 bg-white flex flex-row items-center justify-end gap-3">
  <button type="button" (click)="cancel()" class="px-5 py-2.5 rounded-xl border border-gray-200 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50 transition-colors">Cancel</button>
  <button type="button" [disabled]="saving" (click)="onSave()"
    class="flex items-center gap-2 px-6 py-2.5 rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 font-bold text-sm shadow-md shadow-amber-200 hover:from-amber-300 hover:to-amber-400 active:scale-[0.98] transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none">
    @if (saving) { <span class="inline-block h-4 w-4 rounded-full border-2 border-neutral-900 border-t-transparent animate-spin"></span> }
    @else { <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">check</mat-icon> }
    Add &amp; pick supplier
  </button>
</div>
